/** "获取验证码" 按钮: 发送成功后倒计时 (时长取后端 resend_interval_seconds) */
import { useEffect, useState } from "react";
import { Button } from "@/components/ui";
import { errorDetail } from "@/lib/api-client";
import { useSendSms } from "../hooks";

export function SmsCodeButton({
  phone, purpose, defaultInterval = 60, disabled, onError, onSent,
}: {
  phone: string;
  purpose: "login" | "register";
  defaultInterval?: number;
  disabled?: boolean;
  onError: (msg: string | null) => void;
  onSent?: (msg: string) => void;
}) {
  const send = useSendSms();
  const [left, setLeft] = useState(0);

  useEffect(() => {
    if (left <= 0) return;
    const t = setTimeout(() => setLeft((n) => n - 1), 1000);
    return () => clearTimeout(t);
  }, [left]);

  const onClick = async () => {
    onError(null);
    const p = phone.trim();
    if (!p) {
      onError("请输入手机号");
      return;
    }
    try {
      const r = await send.mutateAsync({ phone: p, purpose });
      setLeft(r.resend_interval_seconds ?? defaultInterval);
      onSent?.(r.message);
    } catch (e) {
      onError(errorDetail(e, "验证码发送失败"));
    }
  };

  const busy = send.isPending || left > 0;
  return (
    <Button
      variant="outline"
      onClick={onClick}
      disabled={disabled || busy}
      className="h-11 w-[7.5rem] shrink-0 text-primary tabular-nums disabled:text-muted-foreground"
    >
      {send.isPending ? "发送中…" : left > 0 ? `${left}s 后重发` : "获取验证码"}
    </Button>
  );
}
